import { FC } from 'react';
import NGSkeleton from 'src/styles/theme/components/NGSkeleton';
import { ETextAlign, ETextType } from 'src/styles/theme/components/NGText/NGText.enum';
import { INGText } from 'src/styles/theme/components/NGText/NGText.type';
import { ETextColor } from 'src/styles/theme/utils/enums';
import {
	StyledHeadingFive,
	StyledHeadingFour,
	StyledHeadingOne,
	StyledHeadingSix,
	StyledHeadingThree,
	StyledHeadingTwo
} from './NGHeading.styles';

const NGHeading: FC<INGText> = ({
	singleLine = false,
	isLoading = false,
	isHidden = false,
	children,
	fontWeight,
	type,
	textColor = ETextColor.white,
	textAlign = ETextAlign.left,
	textTransform,
	firstLetterFactor,
	...otherProps
}) => {
	if (isLoading && !isHidden) {
		return <NGSkeleton width={otherProps.skWidth} height={otherProps.skHeight} />;
	}

	switch (type) {
		case ETextType.h1:
			return (
				<StyledHeadingOne
					singleLine={singleLine}
					textAlign={textAlign}
					isHidden={isHidden}
					textColor={textColor}
					fontWeight={fontWeight}
					textTransform={textTransform}
					firstLetterFactor={firstLetterFactor}
					{...otherProps}
				>
					{children}
				</StyledHeadingOne>
			);
		case ETextType.h2:
			return (
				<StyledHeadingTwo
					singleLine={singleLine}
					textAlign={textAlign}
					isHidden={isHidden}
					textColor={textColor}
					fontWeight={fontWeight}
					textTransform={textTransform}
					firstLetterFactor={firstLetterFactor}
					{...otherProps}
				>
					{children}
				</StyledHeadingTwo>
			);
		case ETextType.h3:
			return (
				<StyledHeadingThree
					singleLine={singleLine}
					textAlign={textAlign}
					isHidden={isHidden}
					textColor={textColor}
					fontWeight={fontWeight}
					textTransform={textTransform}
					firstLetterFactor={firstLetterFactor}
					{...otherProps}
				>
					{children}
				</StyledHeadingThree>
			);
		case ETextType.h4:
			return (
				<StyledHeadingFour
					singleLine={singleLine}
					textAlign={textAlign}
					isHidden={isHidden}
					textTransform={textTransform}
					firstLetterFactor={firstLetterFactor}
					textColor={textColor}
					{...otherProps}
				>
					{children}
				</StyledHeadingFour>
			);
		case ETextType.h5:
			return (
				<StyledHeadingFive
					singleLine={singleLine}
					textAlign={textAlign}
					isHidden={isHidden}
					textTransform={textTransform}
					firstLetterFactor={firstLetterFactor}
					textColor={textColor}
					{...otherProps}
				>
					{children}
				</StyledHeadingFive>
			);
		case ETextType.h6:
			return (
				<StyledHeadingSix
					singleLine={singleLine}
					textAlign={textAlign}
					isHidden={isHidden}
					textTransform={textTransform}
					firstLetterFactor={firstLetterFactor}
					textColor={textColor}
					{...otherProps}
				>
					{children}
				</StyledHeadingSix>
			);
		default:
			return null;
	}
};

export { NGHeading };
